import { call } from '@advanza/api'
import { fetchRegions } from 'actions/regions'
import { useAppSelector } from 'hooks/hooks'
import { useList } from 'hooks/listHooks'
import { normalize, schema } from 'normalizr'
import { useEffect, useState } from 'react'
import relcaimsSchema from 'schemes/reclaimsSchema'
import regionsSchema from 'schemes/regionsSchema'

export function useRegionsList(filterId, defaultOptions) {
    const { countries } = useAppSelector((state) => state.countries)
    return useList(
        filterId,
        {
            url: 'office/regions/get-list',
            schema: regionsSchema,
            reducerKey: 'regions',
        },
        { ...defaultOptions, countries },
    )
}
